export default __webpack_public_path__ + "static/media/img-intro-choice-1-traders@2x.b16379f0.png";